<script setup lang="ts">
  import PlusBorderIcon from '@/shared/assets/icons/PlusBorderIcon.svg';
  import TrashIcon from '@/shared/assets/icons/TrashCurrentColor.svg';
  import { IconImage, Tooltip } from '@/shared/ui';

  withDefaults(
    defineProps<{
      addDisabled?: boolean;
      deleteDisabled?: boolean;
    }>(),
    {
      addDisabled: false,
      deleteDisabled: false,
    }
  );

  const emit = defineEmits<{
    (event: 'add-condition'): void;
    (event: 'delete-rule'): void;
  }>();
</script>

<template>
  <div class="mt-5 flex items-center justify-end gap-4">
    <Tooltip content="Nova condição" placement="top">
      <button
        type="button"
        class="flex size-[52px] items-center justify-center rounded-lg bg-[var(--theme-secondary)] text-white disabled:cursor-not-allowed disabled:bg-gray-02"
        aria-label="Adicionar Então"
        :disabled="addDisabled"
        @click="emit('add-condition')"
      >
        <IconImage :src="PlusBorderIcon" alt="Adicionar Então" />
      </button>
    </Tooltip>
    <Tooltip content="Deletar regra" placement="top">
      <button
        type="button"
        class="flex size-[52px] items-center justify-center rounded-lg border border-gray-02 bg-white-01 text-red-16 disabled:cursor-not-allowed disabled:text-gray-02"
        aria-label="Excluir regra"
        :disabled="deleteDisabled"
        @click="emit('delete-rule')"
      >
        <IconImage :src="TrashIcon" alt="Excluir regra" />
      </button>
    </Tooltip>
  </div>
</template>
